import { jsx as _jsx } from "react/jsx-runtime";
import styled from "@emotion/styled";
import { readableColor } from "polished";
import { useRef } from "react";
import { TextField } from "./TextField";
export function SearchField({ backgroundColor, open, placeholder, searchTerm, onSearch, }) {
    const inputRef = useRef(null);
    const rendeableColor = readableColor(backgroundColor);
    return (_jsx(Container, Object.assign({ textColor: rendeableColor, open: open, onSubmit: e => {
            var _a, _b;
            e.preventDefault();
            onSearch((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "");
        } }, { children: _jsx(TextField, { ref: input => {
                if (input != null && open)
                    input.focus();
                inputRef.current = input;
            }, autoFocus: open, placeholder: placeholder, defaultValue: searchTerm, inputBorderColor: rendeableColor }, void 0) }), void 0));
}
const Container = styled.form(({ textColor, open }) => ({
    left: "4rem",
    position: "absolute",
    top: "calc(25% - ((4rem / 2) - (3.2rem / 2)))",
    transform: open ? "scaleX(1)" : "scaleX(0)",
    transformOrigin: "left center",
    transition: "transform 200ms ease-in-out",
    width: "30rem",
    "& input": {
        color: textColor,
    },
}));
//# sourceMappingURL=SearchField.js.map